/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {PERMISSIONS} from "../../components/auth/auth-constants";



export function sectionsStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.wor', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          }
        }).add('app.adv', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey) && !LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiser.apiKey);
            }
          }
        }).add('app.pol', {
          abstract: true,
          data: {
            app: 'POLITICAL'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.canEditPoliticalResources();
            }
          }
        }).add('app.dat-seg', {
          abstract: true,
          data: {
            app: 'DATA'
          },
          resolve: {
            readOnly: function() {
              return false;
            }
          }
        }).add('app.dat-map', {
          abstract: true,
          data: {
            app: 'DATA'
          },
          resolve: {
            readOnly: function() {
              return false;
            }
          }
        }).add('app.dat-q', {
          abstract: true,
          data: {
            app: 'DATA'
          },
          resolve: {
            readOnly: function() {
              return false;
            }
          }
        }).add('app.inv', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.managePublishing.apiKey) && !LocalUserPermissions.hasAny(PERMISSIONS.axPublisher.apiKey);
            }
          }
        }).add('app.rep', {
          abstract: true,
          data: {
            app: 'ADVERTISING'
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageReportTemplates.apiKey);
            }
          }
        });
  return states.build();
}